import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const FinanceModule = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const supplierContext = params.get('domain') === 'FOURNISSEUR'
    || location.pathname.includes('fournisseur')
    || location.pathname.includes('supplier');
  let target = supplierContext ? '/purchases-module/payments/fournisseur' : '/sales-module/payments';

  if (location.pathname.includes('payment-history')) {
    target = supplierContext ? '/purchases-module/payments/history' : '/sales-module/payments/history';
  } else if (location.pathname.includes('deadline')) {
    target = supplierContext ? '/purchases-module/supplier-deadlines' : '/sales-module/client-deadlines';
  }

  return <Navigate to={`${target}${location.search}`} replace />;
};

export default FinanceModule;
